import React, { useEffect, useState } from "react";
import { NotificationManager } from "react-notifications";
import moment from "moment";
import { getErrorFromResponse } from "../../../../../../../../utility/utils";
import { ProduccionV2Api } from "../../../../api/ProduccionV2Api";

export const DatosTurno = () => {
    const { getTurnoActual, cargando } = ProduccionV2Api();

    const [turnoActual, setTurnoActual] = useState({});

    const GetTurnoActual = async () => {
        try {
            const response = await getTurnoActual();
            setTurnoActual(response || {});
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el turno actual",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
            setTurnoActual({});
        }
    };

    useEffect(() => {
        GetTurnoActual();
    }, []);

    return (
        <div>
            <h5 className="mb-3 text-center">Turno Actual</h5>
            <div className="formulario-fields-row gap-1rem mt-2 mb-3 flex-wrap">
                <div className="formulario-field min-w-150">
                    <label htmlFor="supervisor" className="text-nowrap">
                        {turnoActual && turnoActual.supervisores
                            ? "Supervisores"
                            : "Supervisor"}
                    </label>

                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turnoActual.supervisores}
                    />
                </div>

                <div className="formulario-field min-w-150">
                    <label htmlFor="operador_bascula" className="text-nowrap">
                        Op. báscula
                    </label>

                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turnoActual.operador_bascula || ""}
                    />
                </div>

                <div className="formulario-field min-w-150">
                    <label
                        htmlFor="operador_montacargas"
                        className="text-nowrap"
                    >
                        Op. montacargas
                    </label>

                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turnoActual.operador_montacargas || ""}
                    />
                </div>

                <div className="formulario-field min-w-150">
                    <label htmlFor="turno" className="text-nowrap">
                        Turno
                    </label>

                    <input
                        type="text"
                        className="form-control"
                        disabled
                        value={turnoActual.turno_display || ""}
                    />
                </div>

                <div className="d-flex gap-1rem flex-1">
                    <div className="formulario-field min-w-150">
                        <label htmlFor="fecha_inicial" className="text-nowrap">
                            Fecha inicio
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                turnoActual.fecha_inicial &&
                                moment(turnoActual.fecha_inicial).format(
                                    "DD/MM/YYYY HH:mm",
                                )
                            }
                        />
                    </div>

                    <div className="formulario-field min-w-150">
                        <label htmlFor="fecha_final" className="text-nowrap">
                            Fecha fin
                        </label>

                        <input
                            type="text"
                            className="form-control"
                            disabled
                            value={
                                turnoActual.fecha_final &&
                                moment(turnoActual.fecha_final).format(
                                    "DD/MM/YYYY HH:mm",
                                )
                            }
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
